import zafClient from './api/zendesk';

zafClient.metadata().then(metadata => orderIDField = metadata.settings.orderIDField)

let orderIDField =  0

const vtexProperties = {
    'orderId': 0,
    'sequence': 0,
    'marketplaceOrderId': 0,
    'marketplaceServicesEndpoint': 0,
    'sellerOrderId': 0,
    'origin': 0,
    'affiliateId': 0,
    'salesChannel': 0,
    'merchantName': 0,
    'status': 0,
    'workflowIsInError': 0,
    'statusDescription': 0,
    'value': 0,
    'creationDate': 0,
    'lastChange': 0,
    'orderGroup': 0,
    'totals.id': 0,
    'totals.name': 0,
    'totals.value': 0,
    'items.uniqueId': 0,
    'items.id': 0,
    'items.productId': 0,
    'items.ean': 0,
    'items.lockId': 0,
    'items.itemAttachment.content': 0,
    'items.itemAttachment.name': 0,
    'items.attachments': 0,
    'items.quantity': 0,
    'items.seller': 0,
    'items.name': 0,
    'items.refId': 0,
    'items.price': 0,
    'items.listPrice': 0,
    'items.manualPrice': 0,
    'items.priceTags.name': 0,
    'items.priceTags.value': 0,
    'items.priceTags.isPercentual': 0,
    'items.priceTags.identifier': 0,
    'items.priceTags.rawValue': 0,
    'items.priceTags.rate': 0,
    'items.priceTags.jurisCode': 0,
    'items.priceTags.jurisType': 0,
    'items.priceTags.jurisName': 0,
    'items.imageUrl': 0,
    'items.detailUrl': 0,
    'items.components': 0,
    'items.bundleItems': 0,
    'items.params': 0,
    'items.offerings': 0,
    'items.attachmentOfferings': 0,
    'items.sellerSku': 0,
    'items.priceValidUntil': 0,
    'items.commission': 0,
    'items.tax': 0,
    'items.preSaleDate': 0,
    'items.additionalInfo.brandName': 0,
    'items.additionalInfo.brandId': 0,
    'items.additionalInfo.categoriesIds': 0,
    'items.additionalInfo.categories.id': 0,
    'items.additionalInfo.categories.name': 0,
    'items.additionalInfo.productClusterId': 0,
    'items.additionalInfo.commercialConditionId': 0,
    'items.additionalInfo.dimension.cubicweight': 0,
    'items.additionalInfo.dimension.height': 0,
    'items.additionalInfo.dimension.length': 0,
    'items.additionalInfo.dimension.weight': 0,
    'items.additionalInfo.dimension.width': 0,
    'items.additionalInfo.offeringInfo': 0,
    'items.additionalInfo.offeringType': 0,
    'items.additionalInfo.offeringTypeId': 0,
    'items.measurementUnit': 0,
    'items.unitMultiplier': 0,
    'items.sellingPrice': 0,
    'items.isGift': 0,
    'items.shippingPrice': 0,
    'items.rewardValue': 0,
    'items.freightCommission': 0,
    'items.priceDefinition.sellingPrices.value': 0,
    'items.priceDefinition.sellingPrices.quantity': 0,
    'items.priceDefinition.calculatedSellingPrice': 0,
    'items.priceDefinition.total': 0,
    'items.taxCode': 0,
    'items.parentItemIndex': 0,
    'items.parentAssemblyBinding': 0,
    'items.callCenterOperator': 0,
    'items.serialNumbers': 0,
    'items.assemblies': 0,
    'items.costPrice': 0,
    'items.priceTags': 0,
    'marketplaceItems': 0,
    'clientProfileData.id': 0,
    'clientProfileData.email': 0,
    'clientProfileData.firstName': 0,
    'clientProfileData.lastName': 0,
    'clientProfileData.documentType': 0,
    'clientProfileData.document': 0,
    'clientProfileData.phone': 0,
    'clientProfileData.corporateName': 0,
    'clientProfileData.tradeName': 0,
    'clientProfileData.corporateDocument': 0,
    'clientProfileData.stateInscription': 0,
    'clientProfileData.corporatePhone': 0,
    'clientProfileData.isCorporate': 0,
    'clientProfileData.userProfileId': 0,
    'clientProfileData.userProfileVersion': 0,
    'clientProfileData.customerClass': 0,
    'giftRegistryData': 0,
    'marketingData.id': 0,
    'marketingData.utmSource': 0,
    'marketingData.utmPartner': 0,
    'marketingData.utmMedium': 0,
    'marketingData.utmCampaign': 0,
    'marketingData.coupon': 0,
    'marketingData.utmiCampaign': 0,
    'marketingData.utmipage': 0,
    'marketingData.utmiPart': 0,
    'marketingData.marketingTags': 0,
    'ratesAndBenefitsData.id': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.description': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.featured': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.id': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.name': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.matchedParameters.product@CatalogSystem': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.additionalInfo': 0,
    'ratesAndBenefitsData.rateAndBenefitsIdentifiers.matchedParameters': 0,
    'shippingData.id': 0,
    'shippingData.address.addressType': 0,
    'shippingData.address.receiverName': 0,
    'shippingData.address.addressId': 0,
    'shippingData.address.versionId': 0,
    'shippingData.address.entityId': 0,
    'shippingData.address.postalCode': 0,
    'shippingData.address.city': 0,
    'shippingData.address.state': 0,
    'shippingData.address.country': 0,
    'shippingData.address.street': 0,
    'shippingData.address.number': 0,
    'shippingData.address.neighborhood': 0,
    'shippingData.address.complement': 0,
    'shippingData.address.reference': 0,
    'shippingData.address.geoCoordinates': 0,
    'shippingData.logisticsInfo.itemIndex': 0,
    'shippingData.logisticsInfo.selectedSla': 0,
    'shippingData.logisticsInfo.lockTTL': 0,
    'shippingData.logisticsInfo.price': 0,
    'shippingData.logisticsInfo.listPrice': 0,
    'shippingData.logisticsInfo.sellingPrice': 0,
    'shippingData.logisticsInfo.deliveryWindow.startDateUtc': 0,
    'shippingData.logisticsInfo.deliveryWindow.endDateUtc': 0,
    'shippingData.logisticsInfo.deliveryWindow.price': 0,
    'shippingData.logisticsInfo.deliveryCompany': 0,
    'shippingData.logisticsInfo.shippingEstimate': 0,
    'shippingData.logisticsInfo.shippingEstimateDate': 0,
    'shippingData.logisticsInfo.slas.id': 0,
    'shippingData.logisticsInfo.slas.name': 0,
    'shippingData.logisticsInfo.slas.shippingEstimate': 0,
    'shippingData.logisticsInfo.slas.deliveryWindow.startDateUtc': 0,
    'shippingData.logisticsInfo.slas.deliveryWindow.endDateUtc': 0,
    'shippingData.logisticsInfo.slas.deliveryWindow.price': 0,
    'shippingData.logisticsInfo.slas.price': 0,
    'shippingData.logisticsInfo.slas.deliveryChannel': 0,
    'shippingData.logisticsInfo.slas.pickupStoreInfo.additionalInfo': 0,
    'shippingData.logisticsInfo.slas.pickupStoreInfo.address': 0,
    'shippingData.logisticsInfo.slas.pickupStoreInfo.dockId': 0,
    'shippingData.logisticsInfo.slas.pickupStoreInfo.friendlyName': 0,
    'shippingData.logisticsInfo.slas.pickupStoreInfo.isPickupStore': 0,
    'shippingData.logisticsInfo.slas.polygonName': 0,
    'shippingData.logisticsInfo.slas.lockTTL': 0,
    'shippingData.logisticsInfo.slas.pickupPointId': 0,
    'shippingData.logisticsInfo.slas.transitTime': 0,
    'shippingData.logisticsInfo.slas.pickupDistance': 0,
    'shippingData.logisticsInfo.shipsTo': 0,
    'shippingData.logisticsInfo.deliveryIds.courierId': 0,
    'shippingData.logisticsInfo.deliveryIds.courierName': 0,
    'shippingData.logisticsInfo.deliveryIds.dockId': 0,
    'shippingData.logisticsInfo.deliveryIds.quantity': 0,
    'shippingData.logisticsInfo.deliveryIds.warehouseId': 0,
    'shippingData.logisticsInfo.deliveryIds.accountCarrierName': 0,
    'shippingData.logisticsInfo.deliveryIds.kitItemDetails': 0,
    'shippingData.logisticsInfo.deliveryChannels.id': 0,
    'shippingData.logisticsInfo.deliveryChannels.stockBalance': 0,
    'shippingData.logisticsInfo.deliveryChannel': 0,
    'shippingData.logisticsInfo.pickupStoreInfo.additionalInfo': 0,
    'shippingData.logisticsInfo.pickupStoreInfo.address': 0,
    'shippingData.logisticsInfo.pickupStoreInfo.dockId': 0,
    'shippingData.logisticsInfo.pickupStoreInfo.friendlyName': 0,
    'shippingData.logisticsInfo.pickupStoreInfo.isPickupStore': 0,
    'shippingData.logisticsInfo.addressId': 0,
    'shippingData.logisticsInfo.versionId': 0,
    'shippingData.logisticsInfo.entityId': 0,
    'shippingData.logisticsInfo.polygonName': 0,
    'shippingData.logisticsInfo.pickupPointId': 0,
    'shippingData.logisticsInfo.transitTime': 0,
    'shippingData.trackingHints': 0,
    'shippingData.selectedAddresses.addressId': 0,
    'shippingData.selectedAddresses.versionId': 0,
    'shippingData.selectedAddresses.entityId': 0,
    'shippingData.selectedAddresses.addressType': 0,
    'shippingData.selectedAddresses.receiverName': 0,
    'shippingData.selectedAddresses.street': 0,
    'shippingData.selectedAddresses.number': 0,
    'shippingData.selectedAddresses.complement': 0,
    'shippingData.selectedAddresses.neighborhood': 0,
    'shippingData.selectedAddresses.postalCode': 0,
    'shippingData.selectedAddresses.city': 0,
    'shippingData.selectedAddresses.state': 0,
    'shippingData.selectedAddresses.country': 0,
    'shippingData.selectedAddresses.reference': 0,
    'shippingData.selectedAddresses.geoCoordinates': 0,
    'paymentData.giftCards': 0,
    'paymentData.transactions.isActive': 0,
    'paymentData.transactions.transactionId': 0,
    'paymentData.transactions.merchantName': 0,
    'paymentData.transactions.payments.id': 0,
    'paymentData.transactions.payments.paymentSystem': 0,
    'paymentData.transactions.payments.paymentSystemName': 0,
    'paymentData.transactions.payments.value': 0,
    'paymentData.transactions.payments.installments': 0,
    'paymentData.transactions.payments.referenceValue': 0,
    'paymentData.transactions.payments.cardHolder': 0,
    'paymentData.transactions.payments.cardNumber': 0,
    'paymentData.transactions.payments.firstDigits': 0,
    'paymentData.transactions.payments.lastDigits': 0,
    'paymentData.transactions.payments.cvv2': 0,
    'paymentData.transactions.payments.expireMonth': 0,
    'paymentData.transactions.payments.expireYear': 0,
    'paymentData.transactions.payments.url': 0,
    'paymentData.transactions.payments.giftCardId': 0,
    'paymentData.transactions.payments.giftCardName': 0,
    'paymentData.transactions.payments.giftCardCaption': 0,
    'paymentData.transactions.payments.redemptionCode': 0,
    'paymentData.transactions.payments.group': 0,
    'paymentData.transactions.payments.tid': 0,
    'paymentData.transactions.payments.dueDate': 0,
    'paymentData.transactions.payments.connectorResponses.braspagTransactionId': 0,
    'paymentData.transactions.payments.connectorResponses.tid': 0,
    'paymentData.transactions.payments.connectorResponses.AcquirerTransactionId': 0,
    'paymentData.transactions.payments.connectorResponses.authId': 0,
    'paymentData.transactions.payments.connectorResponses.nsu': 0,
    'paymentData.transactions.payments.connectorResponses.proofOfSale': 0,
    'paymentData.transactions.payments.connectorResponses.returnCode': 0,
    'paymentData.transactions.payments.connectorResponses.returnMessage': 0,
    'paymentData.transactions.payments.connectorResponses.authorizationCode': 0,
    'paymentData.transactions.payments.giftCardProvider': 0,
    'paymentData.transactions.payments.giftCardAsDiscount': 0,
    'paymentData.transactions.payments.koinUrl': 0,
    'paymentData.transactions.payments.accountId': 0,
    'paymentData.transactions.payments.parentAccountId': 0,
    'paymentData.transactions.payments.bankIssuedInvoiceIdentificationNumber': 0,
    'paymentData.transactions.payments.bankIssuedInvoiceIdentificationNumberFormatted': 0,
    'paymentData.transactions.payments.bankIssuedInvoiceBarCodeNumber': 0,
    'paymentData.transactions.payments.bankIssuedInvoiceBarCodeType': 0,
    'paymentData.transactions.payments.billingAddress.postalCode': 0,
    'paymentData.transactions.payments.billingAddress.city': 0,
    'paymentData.transactions.payments.billingAddress.state': 0,
    'paymentData.transactions.payments.billingAddress.country': 0,
    'paymentData.transactions.payments.billingAddress.street': 0,
    'paymentData.transactions.payments.billingAddress.number': 0,
    'paymentData.transactions.payments.billingAddress.neighborhood': 0,
    'paymentData.transactions.payments.billingAddress.complement': 0,
    'paymentData.transactions.payments.billingAddress.reference': 0,
    'paymentData.transactions.payments.billingAddress.geoCoordinates': 0,
    'packageAttachment.packages': 0,
    'sellers.id': 0,
    'sellers.name': 0,
    'sellers.logo': 0,
    'sellers.fulfillmentEndpoint': 0,
    'callCenterOperatorData': 0,
    'followUpEmail': 0,
    'lastMessage': 0,
    'hostname': 0,
    'invoiceData': 0,
    'changesAttachment': 0,
    'openTextField': 0,
    'roundingError': 0,
    'orderFormId': 0,
    'commercialConditionData': 0,
    'isCompleted': 0,
    'customData.customApps.fields.name': 0,
    'customData.customApps.fields.adress': 0,
    'customData.customApps.fields.contact': 0,
    'customData.customApps.fields.businessHourWeekly': 0,
    'customData.customApps.fields.businessHourSaturday': 0,
    'customData.customApps.fields.businessHourSunday': 0,
    'customData.customApps.fields.businessHourHoliday': 0,
    'customData.customApps.fields.returnDate': 0,
    'customData.customApps.fields.sellerEmail': 0,
    'customData.customApps.id': 0,
    'customData.customApps.major': 0,
    'customData.customApps.fields.receiverName': 0,
    'customData.customApps.fields.street': 0,
    'customData.customApps.fields.complement': 0,
    'customData.customApps.fields.neighborhood': 0,
    'customData.customApps.fields.city': 0,
    'customData.customApps.fields.state': 0,
    'customData.customApps.fields.postalCode': 0,
    'storePreferencesData.countryCode': 0,
    'storePreferencesData.currencyCode': 0,
    'storePreferencesData.currencyFormatInfo.CurrencyDecimalDigits': 0,
    'storePreferencesData.currencyFormatInfo.CurrencyDecimalSeparator': 0,
    'storePreferencesData.currencyFormatInfo.CurrencyGroupSeparator': 0,
    'storePreferencesData.currencyFormatInfo.CurrencyGroupSize': 0,
    'storePreferencesData.currencyFormatInfo.StartsWithCurrencySymbol': 0,
    'storePreferencesData.currencyLocale': 0,
    'storePreferencesData.currencySymbol': 0,
    'storePreferencesData.timeZone': 0,
    'allowCancellation': 0,
    'allowEdition': 0,
    'isCheckedIn': 0,
    'marketplace': 0,
    'authorizedDate': 0,
    'invoicedDate': 0,
    'cancelReason': 0,
    'itemMetadata.Items.Id': 0,
    'itemMetadata.Items.Seller': 0,
    'itemMetadata.Items.Name': 0,
    'itemMetadata.Items.SkuName': 0,
    'itemMetadata.Items.ProductId': 0,
    'itemMetadata.Items.RefId': 0,
    'itemMetadata.Items.Ean': 0,
    'itemMetadata.Items.ImageUrl': 0,
    'itemMetadata.Items.DetailUrl': 0,
    'itemMetadata.Items.AssemblyOptions': 0,
    'subscriptionData': 0,
    'taxData': 0,
    'checkedInPickupPointId': 0,
    'cancellationData': 0,
    'clientPreferencesData.locale': 0,
    'clientPreferencesData.optinNewsLetter': 0
}

export const fieldMappings = {
    'totals.value': 'Valor dos Itens',
    'value': 'Valor',
    'orderId': 'Número do pedido',
    'paymentData.transactions.payments.paymentSystemName': 'Forma de pagamento',
    'itemMetadata.Items.SkuName': 'Nome do produto',
    'statusDescription': 'Estado do pedido',
    'items.refId': 'Código de referência',
    'customData.customApps.fields.name': 'Loja',
    'clientProfileData.document': 'Documento',
    'items.sellerSku': 'SKU value',
    'clientProfileData.firstName': 'Primeiro nome',
    'clientProfileData.lastName': 'Último nome',
    'clientProfileData.phone': 'Telefone',
    'shippingData.logisticsInfo.shippingEstimateDate': 'Data de entrega'
  };

export { orderIDField, vtexProperties }
